module.exports = __webpack_public_path__ + "img/wallet_02_complete_1.b4dec97a.png";